import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type { ListOrdersRequest } from '../types/list-orders';
import type { ListOrdersResponse } from '../types/list-orders';

import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import { ENDPOINT } from '../types/list-orders';

export type UseCaseInput = ListOrdersRequest;
export type UseCaseOutput = ListOrdersResponse;

export class ListOrdersUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { page, per_page } = input;

    if (!page && !per_page) throw new Error('Page and per_page are required');

    return this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      endpoint: ENDPOINT,
      method: HttpMethod.GET,
      params: {
        page,
        per_page,
      },
    });
  }
}
